import { render, staticRenderFns } from "./reportCalculations.vue?vue&type=template&id=2b843157&"
import script from "./reportCalculations.vue?vue&type=script&lang=js&"
export * from "./reportCalculations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports